import { render, staticRenderFns } from "./pos-cancel-product-modal.vue?vue&type=template&id=6fdb48ba&scoped=true&"
import script from "./pos-cancel-product-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-cancel-product-modal.vue?vue&type=script&lang=ts&"
import style0 from "./pos-cancel-product-modal.vue?vue&type=style&index=0&id=6fdb48ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb48ba",
  null
  
)

export default component.exports